import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';

import { formateDateAndTime } from "~/utils/utils";
import { useTrans } from '~/hooks/useTrans';
import { IProjectNotification } from "~/providers/admin-interfaces";
import Loader from '~/components/Loader';
import { useLang } from "~/hooks/useLang";

interface IAdminNotificationsTable {
	loading: boolean;
	items: Array<IProjectNotification>;
	onShowBody: (id: IProjectNotification["id"]) => void;
}

export default function AdminNotificationsTable({
	loading = true,
	items = [],
	onShowBody = () => {},
}: IAdminNotificationsTable) {
	const { trans, transHistoryType } = useTrans();
	const { isCzech } = useLang();
	const HEADERS = [
		"adminNotificationsTable.sentAt",
		"adminNotificationsTable.notificationType",
		"adminNotificationsTable.emailRecipients",
		"adminNotificationsTable.emailSubject",
		"adminNotificationsTable.emailBody",
	];

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold" }} key={header}>
						{ trans(header) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map(notification => (<TableRow key={notification.id}>
					<TableCell>
						{ formateDateAndTime(new Date(notification.sentAt), isCzech) }
					</TableCell>
					<TableCell>
						{ transHistoryType(notification.notificationType) }
					</TableCell>
					<TableCell>
						{ notification.emailRecipients }
					</TableCell>
					<TableCell>
						{ notification.emailSubject }
					</TableCell>
					<TableCell>
						<Button onClick={() => onShowBody(notification.id)} variant="outlined">
							{ trans("adminNotificationsTable.showBody") }
						</Button>
					</TableCell>
				</TableRow>)) }
				{ items.length === 0 && <TableRow>
					<TableCell colSpan={HEADERS.length} style={{ textAlign: "center" }}>
						{ loading && <Loader msg={trans("loadingData")} /> }
						{ !loading && trans("emptyTable") }
					</TableCell>
				</TableRow> }
			</TableBody>
		</Table>
	</TableContainer>;
}
